import { ConvexReactClient } from "convex/react";
import { convexUrl } from "./env";

export const convex = new ConvexReactClient(convexUrl, { expectAuth: true });
